// Impresión de la "Orden de aplicación" (receta agronómica) — A4.
const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const n = (v) => Number(v || 0).toLocaleString("es-PY", { maximumFractionDigits: 3 });

export function recetaHtml(r, empresaNombre = "") {
  const filas = (r.items || []).map((it) => `<tr>
    <td>${esc(it.descripcion)}${it.ingrediente_activo ? `<br><span class="mu">${esc(it.ingrediente_activo)}${it.clase_toxicologica ? ` · Clase ${esc(it.clase_toxicologica)}` : ""}</span>` : ""}</td>
    <td class="r">${n(it.dosis_ha)} ${esc(it.unidad_dosis || it.unidad || "")} / Ha</td>
    <td class="r b">${n(it.total_utilizar)} ${esc(it.unidad || "")}</td>
    <td class="r">${it.carencia_dias != null && it.carencia_dias !== "" ? esc(it.carencia_dias) + " días" : "-"}</td>
  </tr>`).join("");
  return `<!doctype html><html><head><meta charset="utf-8"><title>Receta ${esc(r.numero)}</title><style>
    @page{size:A4;margin:14mm}*{box-sizing:border-box}
    body{font-family:Arial,Helvetica,sans-serif;font-size:12px;color:#0f172a;margin:0}
    .top{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #0f172a;padding-bottom:8px;margin-bottom:12px}
    h1{font-size:20px;margin:0;letter-spacing:.5px}.mu{color:#64748b;font-size:10px}
    .grid{display:grid;grid-template-columns:repeat(2,1fr);gap:8px;margin-bottom:14px}
    .box{border:1px solid #cbd5e1;border-radius:6px;padding:6px 9px}.box b{display:block;font-size:9px;color:#64748b;text-transform:uppercase;margin-bottom:2px}
    table{width:100%;border-collapse:collapse;margin-top:6px}th{background:#f1f5f9;text-align:left;font-size:10px;text-transform:uppercase;padding:6px;border:1px solid #cbd5e1}
    td{padding:7px 6px;border:1px solid #cbd5e1;vertical-align:top}.r{text-align:right}.b{font-weight:bold}
    .obs{margin-top:12px;border:1px solid #cbd5e1;border-radius:6px;padding:8px;min-height:50px}
    .firmas{display:flex;justify-content:space-around;margin-top:70px}.firma{width:42%;text-align:center;border-top:1px solid #0f172a;padding-top:5px;font-size:11px}
    .anulada{position:fixed;top:40%;left:12%;font-size:90px;color:rgba(220,38,38,.18);transform:rotate(-25deg);font-weight:bold}
    .pie{margin-top:24px;padding-top:8px;border-top:1px solid #e2e8f0;text-align:center;font-size:9px;color:#94a3b8}
  </style></head><body>
    ${r.estado === "anulada" ? '<div class="anulada">ANULADA</div>' : ""}
    <div class="top"><div><h1>ORDEN DE APLICACIÓN</h1><div class="mu">Receta agronómica N° ${esc(r.numero)}</div></div>
      <div style="text-align:right"><b>${esc(empresaNombre)}</b><div class="mu">Fecha de emisión: ${esc(r.fecha_emision)}${r.factura_numero ? `<br>Venta: ${esc(r.factura_numero)}` : ""}</div></div></div>
    <div class="grid">
      <div class="box"><b>Cliente</b>${esc(r.cliente_nombre)}${r.cliente_ruc ? `<br><span class="mu">RUC: ${esc(r.cliente_ruc)}</span>` : ""}</div>
      <div class="box"><b>Chacra / Área</b>${esc(r.chacra_nombre)}${r.coordenadas ? `<br><span class="mu">${esc(r.coordenadas)}</span>` : ""}</div>
      <div class="box"><b>Superficie</b>${n(r.superficie_ha)} Hectáreas</div>
      <div class="box"><b>Cultivo</b>${esc(r.cultivo)}${r.objetivo ? `<br><span class="mu">Objetivo: ${esc(r.objetivo)}</span>` : ""}</div>
      <div class="box"><b>Ingeniero agrónomo</b>${esc(r.ingeniero_nombre)}<br><span class="mu">Matrícula: ${esc(r.ingeniero_matricula)}</span></div>
      <div class="box"><b>Aplicación</b>${r.fecha_aplicacion ? `Prevista: ${esc(r.fecha_aplicacion)}` : "—"}${r.metodo_aplicacion ? `<br><span class="mu">Método: ${esc(r.metodo_aplicacion)}</span>` : ""}</div>
    </div>
    <table><thead><tr><th>Producto</th><th class="r">Dosis / Ha</th><th class="r">Total a utilizar (Ha × Dosis)</th><th class="r">Carencia</th></tr></thead><tbody>${filas}</tbody></table>
    <div class="obs"><b class="mu">OBSERVACIONES</b><br>${esc(r.observaciones || "")}</div>
    <div class="firmas"><div class="firma">Ingeniero agrónomo<br><span class="mu">${esc(r.ingeniero_nombre)} · Mat. ${esc(r.ingeniero_matricula)}</span></div><div class="firma">Recibí conforme<br><span class="mu">${esc(r.cliente_nombre)}</span></div></div>
    <div class="pie">Este documento fue generado por Sistema AranduJAR-ERP</div>
  </body></html>`;
}

export function imprimirReceta(r, empresaNombre = "") {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.open();
  w.document.write(recetaHtml(r, empresaNombre));
  w.document.close();
  setTimeout(() => { w.focus(); w.print(); }, 450);
  return true;
}

// Tras guardar una venta con receta: busca la receta recién creada y la imprime.
export async function imprimirRecetaDeFactura(API, token, logoTipo, facturaId, empresaNombre = "") {
  try {
    const r = await fetch(`${API}/admin/recetario/recetas?logo_tipo=${encodeURIComponent(logoTipo || "")}&factura_id=${encodeURIComponent(facturaId)}&estado=emitida`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) return;
    const lista = await r.json();
    if (lista?.[0]) imprimirReceta(lista[0], empresaNombre);
  } catch { /* best-effort */ }
}

// Pregunta al backend qué productos de la venta requieren receta (y si el módulo está activo).
// Devuelve [] si no aplica o si falla la consulta (el backend igual valida al guardar).
export async function verificarControlados(API, token, logoTipo, productoIds) {
  const ids = [...new Set((productoIds || []).filter(Boolean).map(String))];
  if (!ids.length) return [];
  try {
    const r = await fetch(`${API}/admin/recetario/verificar`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify({ logo_tipo: logoTipo, producto_ids: ids }),
    });
    if (!r.ok) return [];
    const d = await r.json();
    return d?.activo ? (d.controlados || []) : [];
  } catch { return []; }
}
